export default __webpack_public_path__ + "static/media/emailSent.bd751096.png";